import OrderDetails from './OrderDetails';
import { OrderDetailsProps, OrderDetailsValueProps } from './types';

export type { OrderDetailsProps, OrderDetailsValueProps };
export default OrderDetails;
